module.exports = __webpack_public_path__ + "static/media/gryphon-musee.2d35a7f2.svg";